import AppServiceNewApi from "./AppServiceNewApi";

class OrganizationServiceNewApi extends AppServiceNewApi{
    constructor() {
        super();
        this.path = '/api/internal/v1/organization';
    }
    
    getOrganization(status){
        const URL = status ? `${this.path}?Enable=${status}` : `${this.path}`
        return this.http.get(URL);
    }
    
    getOrganizationById(id){
        return this.http.get(`${this.path}/${id}`);
    }

    createOrganization(body){
        return this.http.post(`${this.path}`, body);
    }
    
    addLogo(id, body){
        return this.http.post(`${this.path}/${id}`, body);
    }
    
    updateOrganization(id, body){
        return this.http.put(`${this.path}/${id}`, body);
    }

    updateLastOrganization(organizationId) {
        return this.http.put(`${this.path}/last-organization?organizationId=${organizationId}`, {})
    }
}
export default OrganizationServiceNewApi;